import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import Button from '@/components/Button/Button';
import { useAuthContext } from '@/contexts/AuthContext';
import { useAppLogout } from '@/hooks/useAppLogout';
import SharedBasketMessageCard from './SharedBasketMessageCard';

const SharedBasketNotRecipient = ({
  token,
}: {
  token: string;
}) => {
  const { user } = useAuthContext();
  const logout = useAppLogout();

  return (
    <SharedBasketMessageCard
      icon="🔒"
      title={
        <FormattedMessage
          id="sharedBasketWrongAccountTitle"
          defaultMessage="This link was shared with a different account"
        />
      }
      body={
        <FormattedMessage
          id="sharedBasketWrongAccountBody"
          defaultMessage="You don't have access to what's behind this link."
        />
      }
      hint={
        <FormattedMessage
          id="sharedBasketWrongAccountHint"
          defaultMessage="If you think this link is meant for you, ask the sender to share it with this account."
        />
      }
    >
      {user?.email && (
        <SignedAs>
          <FormattedMessage
            id="signedInAs"
            defaultMessage="You're signed in as"
          />
          <Email>{user.email}</Email>
        </SignedAs>
      )}
      <FullWidthButton
        variant="contained"
        onClick={() => logout(`/shared/${token}`)}
        aria-label="Switch account"
      >
        <FormattedMessage
          id="switchAccount"
          defaultMessage="Switch account"
        />
      </FullWidthButton>
    </SharedBasketMessageCard>
  );
};

const SignedAs = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '100%',
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  borderRadius: theme.radii.sm,
  background: theme.palette.grey100,
  fontSize: 13,
  color: theme.palette.grey500,
}));

const Email = styled('span')(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.grey900,
  wordBreak: 'break-all',
}));

const FullWidthButton = styled(Button)({
  width: '100%',
  justifyContent: 'center',
});

export default SharedBasketNotRecipient;
